import React, {Component} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Button, Modal, ModalHeader, ModalBody} from 'reactstrap'
import {Mutation, Query} from 'react-apollo'
import ProjectExpensesList from "./ProjectExpensesList";
import ProjectExpenseInput from "./ProjectExpenseInput";

import upsertProjectExpenseMutation from '../../../queries/server/mutations/upsert_project_expenses'
import projectExpenseQuery from '../../../queries/server/project_expense'
import editProjectLocalMutation from '../../../queries/client_side/mutations/edit_project'
import {toast} from "react-toastify";
import Loading from "../Loading";


export default class ProjectExpenses extends Component {

    state = {
        showInput: false,
        showEdit: false,
        expenseID: null
    }

    toggle = () => {
        this.setState({showInput: !this.state.showInput})
    }

    toggleEdit = (id) => {

        console.log('ID', id)

        this.setState({showEdit: !this.state.showEdit, expenseID: id})
    }

    render() {

        const {toggle, toggleEdit} = this
        const {project} = this.props
        const {showInput, showEdit, expenseID} = this.state

        console.log('props', this.props)

        return (
            <Mutation mutation={editProjectLocalMutation}>
                {(editProjectLocalMutationFunc) => (
                    <Mutation mutation={upsertProjectExpenseMutation}>
                        {(upsertProjectExpenseMutationFunc, mut) => (

                            <div>
                                <Button
                                    size="sm"
                                    color={showInput ? 'warning' : 'success'}
                                    onClick={toggle}
                                >
                                    <FontAwesomeIcon color="#fff" icon={showInput ? 'minus' : 'plus'}/>{' '}
                                    {showInput ? 'Cancel' : 'Add Expense'}
                                </Button>
                                <ProjectExpensesList
                                    data={project.expenses}
                                    project_id={project.project_id}
                                    onEdit={this.toggleEdit}
                                    onDownload={(url) => {
                                        window.open(url)
                                    }}
                                    onDelete={(data) => {
                                        toast.success('Expense Removed', {autoClose: 2000})
                                        editProjectLocalMutationFunc({variables: {data}})
                                    }}
                                />


                                <ProjectExpenseInput
                                    isOpen={showInput}
                                    toggle={toggle}
                                    label="Create Expense"
                                    loading={false}
                                    saving={mut.loading}
                                    project_id={project.project_id}
                                    onSave={({user_id, expense_at, destination, description, expense_type, vat, gross, paid_at, file}) => {
                                        upsertProjectExpenseMutationFunc({
                                            variables: {
                                                project_id: project.project_id,
                                                data: {
                                                    project_id: project.project_id,
                                                    user_id,
                                                    expense_at,
                                                    destination,
                                                    description,
                                                    expense_type,
                                                    net: (gross || 0) - (vat || 0),
                                                    vat,
                                                    gross,
                                                    paid_at,
                                                    file
                                                }
                                            }
                                        })
                                            .then(({data}) => {
                                                toast.success('Expense Created', {autoClose: 2000})
                                                editProjectLocalMutationFunc({variables: {data: data.upsertProjectExpense}})
                                                this.toggle()
                                            })
                                    }}
                                />


                                {expenseID && showEdit &&
                                <Query query={projectExpenseQuery} fetchPolicy="network-only"
                                       variables={{id: expenseID}} skip={!expenseID}>
                                    {({data, loading}) => {

                                        if (loading) return (
                                            <Modal isOpen={showEdit}>
                                                <ModalHeader>Edit Expense</ModalHeader>
                                                <ModalBody>
                                                    <Loading/>
                                                </ModalBody>
                                            </Modal>
                                        )

                                        return (
                                            <ProjectExpenseInput
                                                isOpen={showEdit}
                                                toggle={toggleEdit}
                                                label="Edit Expense"
                                                loading={loading}
                                                saving={mut.loading}
                                                {...data.project_expense}
                                                onSave={({id, user_id, expense_at, destination, description, expense_type, vat, gross, paid_at, file}) => {
                                                    upsertProjectExpenseMutationFunc({
                                                        variables: {
                                                            project_id: project.project_id,
                                                            data: {
                                                                id,
                                                                project_id: project.project_id,
                                                                user_id,
                                                                expense_at,
                                                                destination,
                                                                description,
                                                                expense_type,
                                                                net: (gross || 0) - (vat || 0),
                                                                vat,
                                                                gross,
                                                                paid_at,
                                                                file,
                                                                file_path: data.project_expense.file_path
                                                            }
                                                        }
                                                    })
                                                        .then(({data}) => {
                                                            toast.success('Expense Updated', {autoClose: 2000})
                                                            editProjectLocalMutationFunc({variables: {data: data.upsertProjectExpense}})
                                                            this.toggleEdit()
                                                        })
                                                }}
                                            />
                                        )
                                    }}


                                </Query>}


                            </div>

                        )}


                    </Mutation>

                )}
            </Mutation>

        )
    }

}